import CONSTANTS from '../../constants';

export function accounts(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.MEMBER.GET.ACCOUNTS:
            return action.accounts;
        default:
            return state
    }
}